import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { ApiV2Service } from '../../../../services/api-v2.service';
import { Router } from '@angular/router';
import { SpinnerService } from '../../../../services/spinner.service';
import { AuthService } from '../../../../services/auth.service';
import { MessagesModalService } from '../../../../services/messages-modal.service';
import { PartnerCard } from '../../../../interfaces/partner-card.interface';
//import { PublicAuthorsComponent } from '../../../lessons/public-authors/public-authors.component';
import { User } from 'src/app/models/user.model';
import { Organization } from 'src/app/interfaces/organization-info.interface';
import { map } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { formatPercent } from '@angular/common';
import { LibrarysimaComponent } from 'src/app/modules/lessons/librarysima/librarysima.component';

@Component({
  selector: 'app-partner-card',
  templateUrl: './partner-card.component.html',
  styleUrls: ['./partner-card.component.css'],
})
export class PartnerCardComponent implements OnInit {
  scaleCard: string;
  cardSizeScaled: number;
  partnerBool2: boolean;
  partnerUsers: User[] = [];
  partnerBool: boolean;
  organization: Organization;
  partnerBool3: boolean;
  partnerBool4: boolean;
  @Input() cardSize: number;
  @Input() partnerCard: PartnerCard;
  masterpackkey:number=60439
  sizeCard:number;

  constructor(
    private translate: TranslateService,
    private api: ApiV2Service,
    private router: Router,
    private spinner: SpinnerService,
    public auth: AuthService,
    private message: MessagesModalService
  ) {}

  ngOnInit(): void {
    this.organization = this.auth.currentMainOrganization;
    this.getUserByOrganization();
    //console.log(this.partnerBool);
    this.getsizeCard();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.scaleCard = `scale(${this.cardSize / 240})`;
    this.cardSizeScaled = this.cardSize / (this.cardSize / 240);
  }

  getUserByOrganization() {
    this.api
      .getAlternativeService('GET_USERS_BY_ORGANIZATIONS', this.organization.id)
      .pipe(
        map((data) => {
          for (const key in data['results']) {
            if (data['results'].hasOwnProperty(key)) {
              data['results'][key]['isOrgAdmin'] =
                data['results'][key]['is_org_admin'];
              data['results'][key]['isSuperuser'] =
                data['results'][key]['is_superuser'];
              data['results'][key]['organizationRelationship'] =
                data['results'][key]['organization_relationship'];
              delete data['results'][key]['is_org_admin'];
              delete data['results'][key]['is_superuser'];
              delete data['results'][key]['organization_relationship'];
            }
          }
          return data['results'];
        })
      )
      .subscribe(
        (users: User[]) => {
          //console.log(users);
          this.partnerUsers = users;
          const kidint = 23673; //soportekidint@simarobot.com
          const readerpromotion=60436;//readerpromotion@simarobot.com
          const learningenglish=60437;//learningenglish@simarobot.com
          const aulasamigas=60438//contenidosaulasamigas@simarobot.com
          this.partnerBool = users.some((item) => {
            return item.id === kidint || item.id === 14796 || item.id === 9693||item.id===this.masterpackkey;
          });
          this.partnerBool2 = users.some((item) => {
            return item.id === 6669|| item.id===aulasamigas||item.id===this.masterpackkey;
          });
          this.partnerBool3 = users.some((item) => {
            return item.id === 36212 || item.id===readerpromotion||item.id===this.masterpackkey;
          });
          this.partnerBool4 = true
          // users.some((item) => {
          //   return item.id === 50303|| item.id === learningenglish||item.id===this.masterpackkey;
          // });
          //  console.log('public_authorskidint', this.partnerBool);
          //  console.log('public_authorsaulasamigas', this.partnerBool2);
          //  console.log('public_authorsfomento lector', this.partnerBool3);
          //  console.log('public_authors Moe', this.partnerBool4);
          //console.log(this.partnerCard.url)
        },
        (error) => {
          console.log(error);
          this.spinner.showSpinner = false;
        }
      );
  }

  goToInfo() {
    // console.log('card', this.partnerCard);
    // console.log(this.partnerCard.url);
    if (this.partnerBool && this.partnerBool2) {
      //console.log(this.partnerCard.name);
      this.router.navigate(['/lessons/partner-lessons', this.partnerCard.id]); // aca necesito enviar el id del autor
      //console.log(this.router);
    } else if (
      this.partnerBool &&
      (this.partnerCard.id === 23673 ||
        this.partnerCard.id === 14796 ||
        this.partnerCard.id === 9693||this.partnerCard.id===this.masterpackkey)
    ) {
      this.router.navigate(['/lessons/partner-lessons', this.partnerCard.id]);
    } else if (this.partnerBool2 && (this.partnerCard.id === 6669|| this.partnerCard.id===60438||this.partnerCard.id===this.masterpackkey)) {
      this.router.navigate(['/lessons/partner-lessons', this.partnerCard.id]);
    } else if (this.partnerBool3 && (this.partnerCard.id === 36212||this.partnerCard.id===60436||this.partnerCard.id===this.masterpackkey)) {
      this.router.navigate(['/lessons/partner-lessons', this.partnerCard.id]);
    } else if (this.partnerBool4 && (this.partnerCard.id === 50303||this.partnerCard.id===60437||this.partnerCard.id===this.masterpackkey)) {
      this.router.navigate(['/lessons/partner-lessons', this.partnerCard.id,]);
    } else {
      if (
        !this.partnerBool &&
        (this.partnerCard.id === 23673 ||
          this.partnerCard.id === 14796 ||
          this.partnerCard.id === 9693||this.partnerCard.id===this.masterpackkey)
      ) {
        this.message.openDialog(
          'warning',
          this.translate.instant('DIALOGMESSAGEWARNING.ACCESSDENIEDTITLE'),
          this.translate.instant('DIALOGMESSAGEWARNING.ACCESSDENIED1')
        );
      } else if (!this.partnerBool2 && (this.partnerCard.id === 6669|| this.partnerCard.id===60438||this.partnerCard.id===this.masterpackkey)) {
        this.message.openDialog(
          'warning',
          this.translate.instant('DIALOGMESSAGEWARNING.ACCESSDENIEDTITLE'),
          this.translate.instant('DIALOGMESSAGEWARNING.ACCESSDENIED2')
        );
      } else if (!this.partnerBool3 && (this.partnerCard.id === 36212||this.partnerCard.id===60436||this.partnerCard.id===this.masterpackkey)) {
        //aca debe enviar a la pantalla de explicacion fomento lector
        this.router.navigate(['/lessons/partner/kidint']);
        // this.message.openDialog(
        //   'info',
        //   this.translate.instant('DIALOGMESSAGEWARNING.ACCESSDENIEDTITLE'),
        //   this.translate.instant('DIALOGMESSAGEWARNING.ACCESSDENIED3')
        // );
      }else if (!this.partnerBool4 && (this.partnerCard.id === 50303||this.partnerCard.id===60437||this.partnerCard.id===this.masterpackkey)) {
        this.message.openDialog(
          'warning',
          this.translate.instant('DIALOGMESSAGEWARNING.ACCESSDENIEDTITLE'),
          this.translate.instant('DIALOGMESSAGEWARNING.ACCESSDENIED3')
        );
      }
      else{
        this.router.navigate(['/lessons/partner-lessons', this.partnerCard.id]);
      }
    }
  }

getsizeCard(){
  //console.log(this.partnerCard)
  this.sizeCard=this.partnerCard.size
}

checkLock(){
  if((this.partnerCard.id === 25421) ||
  (this.partnerCard.id === 39710) ||
  (this.partnerCard.id === 50303)){
    return false
  }
  else{
    return true
  }
}

}
